import React from 'react'
import Arrolink from '../ArrowLink'
import Notification from './Notification'
import TransactionDetail from './TransactionDetail'
import TextBox from './TextBox'
import FloatingIcon from '../../General/FloatingIcon'



function Collections() {
  return (
    <div>
        <Arrolink/>
        <Notification/>
        <TransactionDetail/>
        <TextBox/>
        <FloatingIcon/>
               
    </div>
  )
}

export default Collections